import { Record } from "immutable";

export const defaultOptionFromJSON = (json: Partial<IDefaultOptionData>): DefaultOptionRecord => {
  const record: IDefaultOptionRecord = { ...(json as any) };

  return new DefaultOptionRecord(record);
};

export interface IDefaultOptionData {
  option_group_uuid: string;
  quantity: number;
}

export interface IDefaultOptionRecord {
  option_group_uuid: string;
  quantity: number;
}

const defaultDefaultOptionProps: IDefaultOptionRecord = {
  option_group_uuid: "",
  quantity: 0,
};

export class DefaultOptionRecord extends Record(defaultDefaultOptionProps) implements IDefaultOptionRecord {}
